module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Aprovar, devolver para o coordenador ou reprovar relatórios técnicos aguardando aprovação'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaRelatorios,
      "search": _vm.search,
      "no-data-text": 'Nenhum relatório encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.id",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'RelatorioTecnico',
              params: {
                idProjeto: props.item.numeroAcaoExtensao,
                idRelatorioExtensao: props.item.id
              }
            }
          }
        }, [_vm._v("\n                Relatório " + _vm._s(props.item.ordem) + "\n              ")])]
      }
    }, {
      key: "item.dtInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicial)))]
      }
    }, {
      key: "item.dtFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFinal)))]
      }
    }, {
      key: "item.tipoRelatorioTecnicoItem",
      fn: function(props) {
        return [_vm._v("\n              " + _vm._s(props.item.tipoRelatorioTecnicoItem === 1 ? "Relatório Parcial" :
          props.item.tipoRelatorioTecnicoItem === 2 ? "Relatório Parcial com Renovação" :
          props.item.tipoRelatorioTecnicoItem === 3 ? "Relatório Final" : "Tipo Inválido") + "\n            ")]
      }
    }, {
      key: "item.situacaoRelatorioTecnicoItem",
      fn: function(props) {
        return [_vm._v("\n              " + _vm._s(props.item.situacaoRelatorioTecnicoItem === 1 ? "Em elaboração" :
          props.item.situacaoRelatorioTecnicoItem === 2 ? "Aguardando aprovação" :
          props.item.situacaoRelatorioTecnicoItem === 3 ? "Aprovado" :
          props.item.situacaoRelatorioTecnicoItem === 4 ? "Reprovado" : "Situação inválida") + "\n            ")]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.usuarioAdministrador()) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "done_outline",
            "color": "green",
            "tooltip": "Aprovar"
          },
          on: {
            "click": function($event) {
              return _vm.toAprovar(props.item.numeroAcaoExtensao, props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.usuarioAdministrador()) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "not_interested",
            "color": "red",
            "tooltip": "Devolver"
          },
          on: {
            "click": function($event) {
              return _vm.toDevolver(props.item.numeroAcaoExtensao, props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.usuarioAdministrador()) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "cancel",
            "color": "black",
            "tooltip": "Reprovar"
          },
          on: {
            "click": function($event) {
              return _vm.toReprovar(props.item.numeroAcaoExtensao, props.item.id)
            }
          }
        }) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaRelatorios.length) + " relatórios\n            ")]
      }
    }], null, false, 1552141823)
  }), _vm._v(" "), _c('br')], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f98ea96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/administracao/relatorios-aprovar-tabela.vue
// module id = 645
// module chunks = 0